'use client';

import Button from '@ui/Button';
import Dialog from '@ui/Dialog';
import Input from '@ui/Input';
import Typography from '@ui/Typography';
import useShareModalStore from '@/components/store/shareModalSlice';
import React, { useEffect, useState } from 'react';
import { MdContentCopy, MdDone } from 'react-icons/md';
import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from 'react-share';

const iconSize = 65;
const windowSize = {
  width: 1024,
  height: 768,
};

function ShareDialog(props) {
  const isOpen = useShareModalStore((state) => state.open);
  const setIsOpen = useShareModalStore((state) => state.setOpen);
  const metadata = useShareModalStore((state) => state.metadata);

  const shareUrl = metadata.url || 'https://www.neki.io';
  const title = metadata.title || 'Neki';
  const description = metadata.description || '';

  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (copied) {
      setTimeout(() => {
        setCopied(false);
      }, 600);
    }
  }, [copied]);

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleLinkCopy = () => {
    navigator.clipboard.writeText(shareUrl);
    setCopied(true);
  };

  return (
    <Dialog isOpen={isOpen} onClose={handleClose}>
      <div className="flex flex-col items-center gap-8">
        <Typography variant="h2" className="mb-4">
          Share
        </Typography>
        <div className="flex justify-start items-center gap-5 flex-wrap">
          <EmailShareButton
            url={shareUrl}
            subject={title}
            body={`${description} \n\n`}>
            <EmailIcon
              size={iconSize}
              windowWidth={windowSize.width}
              windowHeight={windowSize.height}
              round
            />
          </EmailShareButton>

          <WhatsappShareButton
            url={shareUrl}
            title={title}
            separator=" "
            windowWidth={windowSize.width}
            windowHeight={windowSize.height}
            onClick={handleClose}>
            <WhatsappIcon size={iconSize} round />
          </WhatsappShareButton>

          <FacebookShareButton
            url={shareUrl}
            quote={title}
            windowWidth={windowSize.width}
            windowHeight={windowSize.height}
            onClick={handleClose}>
            <FacebookIcon size={iconSize} round />
          </FacebookShareButton>

          <TwitterShareButton
            url={shareUrl}
            title={title}
            windowWidth={windowSize.width}
            windowHeight={windowSize.height}
            onClick={handleClose}>
            <TwitterIcon size={iconSize} round />
          </TwitterShareButton>

          <LinkedinShareButton
            url={shareUrl}
            title={encodeURIComponent(title)}
            summary={encodeURIComponent(description)}
            source="Neki"
            windowWidth={windowSize.width}
            windowHeight={windowSize.height}
            onClick={handleClose}>
            <LinkedinIcon size={iconSize} round />
          </LinkedinShareButton>
        </div>

        <div className="flex justify-between items-center gap-5 w-full">
          <div className="flex-1">
            <Input value={shareUrl} disabled />
          </div>
          <Button variant="filled" color="primary" onClick={handleLinkCopy}>
            {!copied ? <MdContentCopy /> : <MdDone className="animate-pulse" />}
          </Button>
        </div>
      </div>
    </Dialog>
  );
}

export default ShareDialog;
